import { call, put, takeEvery, select } from "redux-saga/effects";
import { saveAs } from "file-saver";
import { fetchAPI } from "../../utils/service";
import endpoints, { endpointTypes } from "../../service";
import generatePdfDocument from "./summaryPDFDownload";
import * as ACTIONS from "./actionCreators";
import * as CART_ACTIONS from "../MyCart/actionCreators";
import * as ACTION_TYPES from "./actionTypes";
import * as GlobalAction from "../../globalStore/actions";
import * as CONFIG from "../../../config.json";
import { PersistData } from "../../middleware/persistDataMiddleware";
import { getPersistData, setPersistData, parseResponseData } from "../../utils/utils";

const REST_ENDPOINT = endpoints[endpointTypes.THANK_YOU].endpoints;

let validateCount = 0;

export const getWarrantyId = (state) => {
    return state.dynamicFormInfo && state.dynamicFormInfo.warrantyId;
};
/**
 * Initialize transaction
 * @param payload
 * @ignore
 */
export function* initiateTransaction({ payload }: ReturnType<typeof ACTIONS.initiateTransaction>) {
    const warrantyId = yield select(getWarrantyId);
    yield put(ACTIONS.updateInitTransaction());
    if (warrantyId) {
        const endpoint = REST_ENDPOINT.beginTransaction({ warrantyId: warrantyId, ...payload });
        try {
            const response = yield call(fetchAPI, endpoint);
            if (response) {
                yield put(ACTIONS.updateNavigation(response.data));
            }
        } catch (err) {
            yield put(GlobalAction.showGlobalError(err));
        }
    } else {
        yield put(GlobalAction.showGlobalError(""));
    }
    yield put(ACTIONS.updateInitTransactionCompleted());
}

/**
 * validate payment by transaction id
 * @param payload
 * @ignore
 */
export function* validatePayment({ payload }: ReturnType<typeof ACTIONS.validateTransaction>) {
    const endpoint = REST_ENDPOINT.validateTransaction({
        id: payload.id,
        status: payload.status,
    });
    try {
        // let warrantyId = "";
        if (payload.isMakeValidateTransaction) {
            validateCount++;
            const response = yield call(fetchAPI, endpoint);
            if (response && response.data && payload.status === 1) {
                const checkoutItems = parseResponseData(response.data);
                const { shoppingCartId } = response.data;
                yield put(ACTIONS.updateTransactionData({ warranties: checkoutItems, shoppingCartId }));
                validateCount = 0;
                let persistData: PersistData = getPersistData() || {};
                persistData = Object.assign(persistData, {
                    shoppingCartId: response.data.shoppingCartId,
                });
                delete persistData.warrantyId;
                setPersistData(persistData);
                // yield put(ACTIONS.updateTransactionData(pdfData));
                // warrantyId = response.data.warrantyId;
            }
        }
        if (payload.status === 2 || payload.status === 3) {
            yield put(ACTIONS.updateTransactionFailed());
        }
    } catch (err) {
        const errStatus = err && err.response && err.response.status;
        if (
            CONFIG.CONFIG.processTransactionRetryErrorCode.includes(errStatus) &&
            validateCount < CONFIG.CONFIG.processTransactionRetryThreshold &&
            payload.status === 1
        ) {
            yield put(ACTIONS.validateTransaction(payload));
        } else {
            const persistData: PersistData = getPersistData() || {};
            yield put(
                CART_ACTIONS.getActiveShoppingCartSuccess({
                    data: { shoppingCartId: persistData.shoppingCartId } 
                })
            );
            const msg = err.Message || (err.response && err.response.data && err.response.data.Message);
            yield put(GlobalAction.showGlobalError({ Message: msg }));
            yield put(ACTIONS.updateTransactionFailed());
        }
    }
}

export function* generateFullWarranty({ payload }: ReturnType<typeof ACTIONS.generateFullWarranty>) {
    const endpoint = REST_ENDPOINT.generateFullPDF(payload.warrantyId);
    try {
        const response = yield call(fetchAPI, endpoint);
        if (response) {
            // const fileName = `WarrantyPDF_${payload.warrantyId}.pdf`;
            const fileName = `WarrantyPDF_${payload.warrantyNumber}.pdf`;
            if (window.navigator && (window.navigator as any).msSaveOrOpenBlob) {
                // IE variant
                (window.navigator as any).msSaveOrOpenBlob(
                    new Blob([response.data], {
                        type: "application/pdf",
                    }),
                    fileName
                );
                yield put(ACTIONS.generateFullWarrantyDownloaded());
            } else {
                const url = window.URL.createObjectURL(
                    new Blob([response.data], {
                        type: "application/pdf",
                    })
                );
                const link = document.createElement("a");
                link.href = url;
                link.setAttribute("download", fileName);
                document.body.appendChild(link);
                link.click();
                yield put(ACTIONS.generateFullWarrantyDownloaded());
                setTimeout(function () {
                    // For Firefox it is necessary to delay revoking the ObjectURL
                    window.URL.revokeObjectURL(url);
                }, 100);
            }
        }
    } catch (e) {
        console.error(e);
        yield put(ACTIONS.generateFullWarrantyDownloaded());
    }
}

export function* generateSummaryWarranty({ payload }: ReturnType<typeof ACTIONS.generateSummaryWarranty>) {
    const { warrantyId, summaryPDFData, warrantyNumber } = payload;
    // const reviewAndPayEndpoint = REST_ENDPOINT.reviewAndPay.endpoints.getReviewAndPay(warrantyId);
    const reviewAndPayEndpoint = REST_ENDPOINT.reviewAndPay.endpoints.getReviewAndPay(warrantyNumber);
    try {
        const reviewAndPayResponse =
            !summaryPDFData || !Object.keys(summaryPDFData).length
                ? yield call(fetchAPI, reviewAndPayEndpoint)
                : { data: summaryPDFData };
        if (reviewAndPayResponse) {
            const button = document.createElement("button");
            button.onclick = () => generatePdfDocument(JSON.parse(reviewAndPayResponse.data), warrantyId, warrantyNumber);
            button.style.display = "none";
            document.body.appendChild(button);
            button.click();
            yield put(ACTIONS.generateSummaryWarrantyDownloaded());
        }
    } catch (err) {
        yield put(GlobalAction.showGlobalError(err));
        yield put(ACTIONS.generateSummaryWarrantyDownloaded());
    }
}

export function* downloadAllWarranties() {
    const persistData: PersistData = getPersistData() || {};
    const { shoppingCartId } = persistData;
    const endpoint = REST_ENDPOINT.downloadAllWarranties(shoppingCartId);
    try {
        const response = yield call(fetchAPI, endpoint);
        if (response && response.data) {
            const fileName = `ShoppingCart_WarrantyPDF_${shoppingCartId}.zip`;
            saveAs(
                new Blob([response.data], {
                    type: "application/zip",
                }),
                fileName
            );
            yield put(ACTIONS.downloadAllWarrantiesSuccess());
        } else {
            yield put(GlobalAction.showGlobalError({ Message: "Download All failure" }));
            yield put(ACTIONS.downloadAllWarrantiesFailure());
        }
    } catch (err) {
        yield put(GlobalAction.showGlobalError({ Message: err.message }));
        yield put(ACTIONS.downloadAllWarrantiesFailure());
    }
}

export function* multipleWarrantiesThankYou() {
    yield takeEvery(ACTION_TYPES.DOWNLOAD_ALL_WARRANTIES, downloadAllWarranties);
    yield takeEvery(ACTION_TYPES.GENERATE_FULL_WARRANTY_FOR_MULTIPLE_WARRANTIES, generateFullWarranty);
    yield takeEvery(ACTION_TYPES.GENERATE_SUMMARY_WARRANTY_FOR_MULTIPLE_WARRANTIES, generateSummaryWarranty);
    yield takeEvery(ACTION_TYPES.INITIATE_TRANSACTION_FOR_MULTIPLE_WARRANTIES, initiateTransaction);
    yield takeEvery(ACTION_TYPES.VALIDATE_TRANSACTION_FOR_MULTIPLE_WARRANTIES, validatePayment);
}

export function* beginTransaction() {
    yield takeEvery(ACTION_TYPES.INITIATE_TRANSACTION_FOR_MULTIPLE_WARRANTIES, initiateTransaction);
}

export function* validateTransaction() {
    yield takeEvery(ACTION_TYPES.VALIDATE_TRANSACTION_FOR_MULTIPLE_WARRANTIES, validatePayment);
}
